import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import VirtualSportsHeader from './virtualsports_header'
import GamesService from '../services/casinoGamesService'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import '../css/casino/index.css'
import '../css/casino/style.css'
import '../css/casino/responsive.css'
import CasinoCurrencyModal from './sub_components/casinoCurrencyModal';
import { casinoCurrencyList } from '../configs/casinoCurrencyList';
let oid = OPERATOR_ID.toLowerCase()
class VirtualSports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            games: [],
            allGames: [],
            operator: OPERATOR_ID,
            gameType: "ALL",
            gameCategory: "All",
            gamePartner: "All",
            openGame: false,
            link: "",
            loader: false,
            showPopup: false
        };
    }
    changeGameType(game_type) {
        let self = this
        this.setState({ gameType: game_type, loader: true }, () => {
            self.filterParnterGameType(this.state.allGames)
        })
    }

    componentWillReceiveProps() {
        this.setState({ loader: true })
        setTimeout(() => {
            const self = this;
            const operator = this.state.operator
            let token = JSON.parse(localStorage.getItem('userAuthDetail'))
            token = token.token
            if (!!operator && !!token) {
                window.localStorage.setItem("operator", operator);
                window.localStorage.setItem("token", token);
                let gameType = "ALL"
                self.setState({ "operator": operator, gameType: gameType }, () => {
                    window.setTimeout(function () {
                        self.loadGames();
                    }, 100);
                });
            }
        }, 100)
    }
    componentDidMount() {
        this.setState({ loader: true, showPopup: casinoCurrencyList["VSPORTS"].currencyEquals === '1' ? false : true })
        setTimeout(() => {
            const self = this;
            const operator = this.state.operator
            let token = JSON.parse(localStorage.getItem('userAuthDetail'))
            token = token.token
            if (!!operator && !!token) {
                window.localStorage.setItem("operator", operator);
                window.localStorage.setItem("token", token);
                let gameType = "ALL"
                self.setState({ "operator": operator, gameType: gameType }, () => {
                    window.setTimeout(function () {
                        self.loadGames();
                    }, 100);
                });
            }
        }, 100)
    }
    loadGames = async () => {
        const operator = this.state.operator
        let token = JSON.parse(localStorage.getItem('userAuthDetail'))
        token = token.token
        if (!!operator && !!token) {
            window.setTimeout(function () {
                this.getEnglishGames();
            }.bind(this), 1500)
        }
    }
    getEnglishGames = () => {
        GamesService.getEnglishGames().then((res) => {
            this.filterParnterGameType(res.data)
        }).catch((e) => { });
    }

    filterParnterGameType(data) {
        const gameType = this.state.gameType;
        const gamesData = data;
        let games = [];
        if (gameType === "ALL") {
            games = gamesData.filter((game) => game.partner === "Kiron" || game.partner === "Edge Gaming" || game.partner === "Golden Race" || game.partner === "Spadegaming" || game.partner === "Spribe");
        }
        else {
            games = gamesData.filter((game) => game.category === gameType && (game.partner === "Kiron" || game.partner === "Edge Gaming" || game.partner === "Golden Race" || game.partner === "Spadegaming" || game.partner === "Spribe"));
        }

        this.setState({ allGames: gamesData, games: games, isLoading: false, loader: false });
    }

    getIndividualGame = async (gameId) => {
        this.setState({ isLoading: true });
        const gameRes = await GamesService.getIndividualGame(gameId);
        const gameData = gameRes.data;
        if (!gameData && !gameRes.isSuccess && !!gameRes?.exception?.message) {
            this.props.MySwal.fire({
                title: 'Error',
                text: `${gameRes?.exception?.code} ${gameRes?.exception?.message}`,
                icon: 'error',
                confirmButtonText: 'OK',
            })
            this.setState({ loader: false });
            // this.setState({ popupMessage: gameRes.message });
        }
        if (!!gameData && !!gameData.url) {
            this.setState({ openGame: true, link: gameData.url })
        }
    }
    hideCurrencyPopup() {
        this.setState({ showPopup: false });
    }
    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    <div className="col-center1 markets">
                        <section>
                            <div className="sub_path center-box"><p>Virtual Sports</p></div>
                            <div className={`container-fluid casino-content-page ${this.state.operator}`} >
                                {this.state.openGame !== true ? <>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="loader-bg" style={{ display: this.state.isLoading ? "flex" : "none" }}>
                                                <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.isLoading ? "loader-image-active" : "loader-image-active"}`} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <div className="loader-bg" style={{ display: this.state.loader ? "flex" : "none" }}>
                                                <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.loader ? "loader-image-active" : "loader-image-active"}`} />
                                            </div>
                                        </div>
                                    </div>
                                    {!this.state.loader && !this.state.isLoading &&
                                        <div className="row">
                                            <div className="text-center mb-0">
                                                <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/virtualsportbanner.jpg"} ></img>
                                            </div>
                                        </div>
                                    }
                                    {!this.state.loader && !this.state.isLoading && <VirtualSportsHeader gameType={this.state.gameType} loader={this.state.loader} changeGameType={(type) => { this.changeGameType(type) }} gamePartner={this.state.gamePartner} />}

                                    {!this.state.loader && !this.state.isLoading &&
                                        <>
                                            <div className="row mt-4 mb-2 featured-game1">
                                                {
                                                    this.state.games.map((game) => (
                                                        <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2" key={game.gameId} onClick={() => this.getIndividualGame(game.gameId)}>
                                                            <div className="img-pos">
                                                                <img alt="" src={BASE_IMAGE_PATH + `/virtualsports/${game.gameId}.jpg`} className="img-fluid" />
                                                                {
                                                                    game.isNew &&
                                                                    <div className="newgame"></div>
                                                                }
                                                                {
                                                                    game.isPopular &&
                                                                    <div className="hotgame"></div>
                                                                }
                                                            </div>
                                                            <div className="text-center game-title-main">{game.gameName}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            {/* } */}
                                        </>
                                    }
                                </> :
                                    <div className="row">
                                        <div onClick={() => { this.setState({ openGame: false, isLoading: false }) }} style={{ position: "absolute", width: "30px", textAlign: "center" }}><i className="fa fa-times popup-cross"></i></div>
                                        <iframe title={"iframe"} key={"iframe"} style={{ height: "84vh", width: "100%", border: "0px" }} src={this.state.link}></iframe>
                                    </div>
                                }
                            </div>
                        </section>

                    </div>

                    {this.state.showPopup && <>
                        <CasinoCurrencyModal currencyEquals={casinoCurrencyList["VSPORTS"].currencyEquals} fileNM={"casinopoint"} hidePopup={() => { this.hideCurrencyPopup() }} />
                        {/* <div id="marketbetspopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                            <div className="modal-dialog modal-sm modal-dialog-centered encasino">
                                <div className="modal-content">                                   
                                    <div className="modal-body engcasinomodalbgimg">
                                        <button onClick={() => { this.setState({ showPopup: false }) }} type="button" className="close text-white ecasinobtnclose" data-dismiss="modal" aria-hidden="true">×</button>
                                            <img alt="" src={`${BASE_IMAGE_PATH}/casino/banner/images/new-popup.png`} className="img-fluid" />
                                        <button type="button" className='virtual-close-btn' onClick={() => { this.setState({ showPopup: false }) }} data-dismiss="modal">&nbsp;</button>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-backdrop fade show" onClick={() => { }}></div>
                        </div> */}
                    </>}
                </div>
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(VirtualSports);